/* import __COLOCATED_TEMPLATE__ from './appointments-feature-details-modal.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { WorkflowState } from '@square/appointments-feature-upsell/constants';
let AppointmentsFeatureDetailsModalComponent = (_class = class AppointmentsFeatureDetailsModalComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "appointmentsFeatureInfo", _descriptor, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "appointmentsMarketContext", _descriptor4, this);
    _initializerDefineProperty(this, "appointmentsSubscriptionModal", _descriptor5, this);
    _initializerDefineProperty(this, "isFeatureDetailsVisible", _descriptor6, this);
    _initializerDefineProperty(this, "type", _descriptor7, this);
    this.dataApi.track('Page', {
      platform: 'web',
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken,
      feature: this.args.featureId
    });
  }
  get emphasizedPlanToken() {
    return this.appointmentsFeatureInfo.getPlanTokenOfFeature(this.args.featureId);
  }
  subscribeNow() {
    if (this.emphasizedPlanToken) {
      this.openSubscriptionModal(this.emphasizedPlanToken);
    }
  }
  showSubsPlansDetails() {
    this.isFeatureDetailsVisible = false;
    this.dataApi.track('Click Page', {
      platform: 'web',
      item_clicked: 'compare plans',
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken,
      feature: this.args.featureId
    });
  }
  showFeatureDetails() {
    this.isFeatureDetailsVisible = true;
  }
  trackPlanSelection() {
    this.dataApi.track('Click Page', {
      platform: 'web',
      item_clicked: 'upgrade plan',
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken,
      feature: this.args.featureId
    });
  }
  openSubscriptionModal(planToken) {
    this.appointmentsSubscriptionModal.open({
      planToken,
      subscriptionToken: this.appointmentsSubscription.token
    }).then(({
      didSubscribe
    }) => {
      if (didSubscribe) {
        window.location.reload();
      }
    });
  }
  onLoadModal() {
    this.appointmentsMarketContext.setIncreaseMarketZIndex?.(true);
  }
  onDismissModal() {
    this.appointmentsMarketContext.setIncreaseMarketZIndex?.();
    this.dataApi.track('Click Page', {
      platform: 'web',
      item_clicked: 'dismiss feature upsell',
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken,
      feature: this.args.featureId
    });
    this.args.onDismiss?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsFeatureInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "appointmentsMarketContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscriptionModal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isFeatureDetailsVisible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "type", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return WorkflowState.UPGRADING;
  }
}), _applyDecoratedDescriptor(_class.prototype, "subscribeNow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "subscribeNow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSubsPlansDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showSubsPlansDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showFeatureDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showFeatureDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackPlanSelection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackPlanSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onLoadModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onLoadModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDismissModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDismissModal"), _class.prototype), _class);
export { AppointmentsFeatureDetailsModalComponent as default };